import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { SettingsLayout } from "@/pages/SettingsBranding";
import { toast } from "sonner";
import { Plus, Trash2, ToggleLeft } from "lucide-react";

export default function SettingsVisitorTypes() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/visitor-types/manage"); setTypes(data); }
    catch (e) { setErr(formatApiError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (t) => {
    try { await api.patch(`/visitor-types/${t.id}`, { active: !t.active }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <SettingsLayout>
      <div data-testid="visitor-types-page">
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-navy-500">Visitor types control which fields the kiosk requires for each kind of visitor.</p>
        </div>
        {err && <div className="text-sm text-danger mb-3">{err}</div>}
        <div className="eb-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-surface text-xs uppercase tracking-wider text-navy-500">
              <tr>
                <th className="text-left px-5 py-3">Type</th>
                <th className="text-left px-5 py-3">Required fields</th>
                <th className="text-left px-5 py-3">Auto-purpose</th>
                <th className="text-left px-5 py-3">Active</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan="4" className="px-5 py-6 text-navy-500">Loading…</td></tr> : types.map((t) => (
                <tr key={t.id} className="border-t border-navy-100" data-testid={`visitor-type-${t.name}`}>
                  <td className="px-5 py-3 font-medium">{t.name}</td>
                  <td className="px-5 py-3 text-xs text-navy-600">{(t.required_fields || []).join(", ")}</td>
                  <td className="px-5 py-3 text-xs text-navy-600">{t.auto_purpose || "—"}</td>
                  <td className="px-5 py-3">
                    <button onClick={() => toggle(t)} className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded ${t.active ? "bg-success/15 text-success" : "bg-navy-100 text-navy-500"}`} data-testid={`toggle-${t.name}`}>
                      <ToggleLeft className="w-3 h-3" /> {t.active ? "Active" : "Inactive"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </SettingsLayout>
  );
}
